import { WidgetConfig } from '@/types';

export const defaultConfig: WidgetConfig = {
  logoText: 'VOTRE LOGO',
  logoUrl: '/logo_client.avif',  // Fallback to local logo if no URL provided
  clientName: 'equimmox',
  primaryColor: '#000000',
  secondaryColor: '#666666',
  withPhone: false,  // Phone field is hidden by default
};
